/**
 * Shell placeholders for remesas sections that ship in fase 2.5.
 * Each shell is a navigable card with the section's icon, title, and a
 * friendly "próximamente" message. No backend dependencies.
 */
import { Card } from '@/components/ui/card';
import { Users, UserCog, UserSquare2, HelpCircle, MessageCircle, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const Shell = ({ Icon, title, blurb, items, testid }) => (
  <div className="space-y-4 max-w-2xl" data-testid={testid}>
    <div>
      <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2"><Icon className="w-6 h-6 text-amber-600" />{title}</h1>
      <p className="text-xs text-slate-500 mt-1">{blurb}</p>
    </div>
    <Card className="border-0 shadow-sm p-6 bg-amber-50 border-l-4 border-amber-400">
      <div className="flex items-start gap-3">
        <Sparkles className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold text-amber-900">Próximamente · Fase 2.5</p>
          <p className="text-sm text-amber-700 mt-1">Esta sección se habilitará cuando se valide volumen real. Mientras tanto:</p>
          <ul className="text-sm text-amber-800 mt-2 list-disc list-inside space-y-1">
            {items.map((i) => <li key={i}>{i}</li>)}
          </ul>
          <Link to="/remesas" className="text-xs text-amber-900 underline mt-3 inline-block">← Volver a Inicio</Link>
        </div>
      </div>
    </Card>
  </div>
);

export const GestorPromotoresPage = () => (
  <Shell
    Icon={Users}
    title="Lista de Promotores"
    blurb="Promotores externos que captan clientes para tu red."
    items={[
      'Alta y baja de promotores con comisión configurable',
      'Tracking de clientes referidos por cada promotor',
      'Liquidación periódica de comisiones',
    ]}
    testid="gestor-promotores-page"
  />
);

export const GestorTrabajadoresPage = () => (
  <Shell
    Icon={UserCog}
    title="Trabajadores Exteriores"
    blurb="Equipo operativo en el destino (Cuba) que entrega remesas."
    items={[
      'Lista con disponibilidad y zona asignada',
      'Asignación automática por zona y volumen',
      'Reporte de entregas pendientes y entregadas',
    ]}
    testid="gestor-trabajadores-page"
  />
);

export const GestorUsuariosPage = () => (
  <Shell
    Icon={UserSquare2}
    title="Usuarios"
    blurb="Clientes finales asignados a tu cartera."
    items={[
      'Listado con historial de remesas por cliente',
      'Score de fidelidad / volumen acumulado',
      'Datos de contacto y observaciones internas',
    ]}
    testid="gestor-usuarios-page"
  />
);

export const GestorFaqPage = () => (
  <Shell
    Icon={HelpCircle}
    title="Preguntas Frecuentes"
    blurb="Respuestas rápidas a las dudas más comunes del operativo."
    items={[
      '¿Cuánto demora una remesa en CUP?',
      '¿Cómo subo correctamente un comprobante?',
      '¿Qué pasa si el método de pago se rechaza?',
    ]}
    testid="gestor-faq-page"
  />
);

export const GestorSoportePage = () => (
  <Shell
    Icon={MessageCircle}
    title="Soporte"
    blurb="Canal directo con el equipo administrativo."
    items={[
      'Chat con admin sobre operaciones específicas',
      'Tickets de soporte con prioridad y SLA',
      'Anuncios oficiales de la plataforma',
    ]}
    testid="gestor-soporte-page"
  />
);
